import { FC, SetStateAction, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Input, PopoverInput } from '@ui/components/Input'

import { IntroducingBrokerReferralDetailsDto } from '@model/IntroducingBrokerDetailsDto'

import { PromoAssetFields } from './PromoPreview.modal'

interface Props {
  referralCodes: IntroducingBrokerReferralDetailsDto[]
  isRefMaterialLoading: boolean
  fields: PromoAssetFields
  setField: (value: SetStateAction<PromoAssetFields>) => void
}

export const PromoReferralCodeField: FC<Props> = ({
  fields,
  setField,
  referralCodes,
  isRefMaterialLoading,
}) => {
  const { t } = useTranslation()

  const options = referralCodes.map((referralCode) => ({
    id: referralCode.mainIbScheme.id,
    name: referralCode.code,
  }))

  const isSingleOption = options.length === 1
  const singleOption = options[0]

  useEffect(() => {
    if (isSingleOption && fields.referralCode?.id !== singleOption.id) {
      setField((prevFields) => ({ ...prevFields, referralCode: singleOption }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSingleOption, singleOption?.id])

  if (isSingleOption) {
    return (
      <Input
        size='lg'
        label={t('IB.Your Referral Code')}
        value={singleOption.name}
        readOnly
        disabled
      />
    )
  }

  return (
    <PopoverInput
      onChange={(referralCode) => {
        setField((prevFields) => ({ ...prevFields, referralCode }))
      }}
      size='lg'
      label={t('IB.Your Referral Code')}
      dropdownListVariant='compact'
      options={options}
      value={fields.referralCode?.id}
      disabled={isRefMaterialLoading}
    />
  )
}
